export const complementaryColors = {
    coolgrey550: '#888A93',
    coolgrey450: '#9DA3A8',
    coolgrey350: '#D3D8DE',
    coolgrey250: '#E9EBEE',
    warmgrey550: '#969694',
    warmgrey650: '#6E6E6C',
    warmgrey725: '#343431',
    strawberry700: '#E98888',
    ultramarine350: '#8A97DA',
    ultramarine950: '#32343B',
    golden: '#A9943C',
};
//# sourceMappingURL=complementary-colors.js.map